export interface HealthInfo {
  status: 'UP' | 'DOWN' | 'LOADING';
  details?: Record<string, {
    status: string;
    details: {
      connected: boolean;
      port: number | string;
      name: string;
      host: string;
      timeout: string;
    };
  }>;
}

export interface AvsInfo {
  host: string;
  port: string | number;
  timeout: string;
}

export const getAvsInfo = (): Promise<AvsInfo> => {
  return fetch('/avs-info').then((res) => res.json());
};

export const checkHealth = ():Promise<HealthInfo> => {
  return fetch('/avs-health').then((res) => res.json());
};
